<template>
  <div>
    <base-header class="pb-6 pb-8 pt-5 pt-md-8 bg-gradient-success">
      <b-button variant="secondary" class="ml-2 mt-3" @click="$router.go(-1)">
        <i class="fas fa-arrow-left"></i> {{ $t('volver') }}
      </b-button>

      <b-container style="max-width: 90%; margin: auto;">
        <b-row>
          <b-col md="12" class="mt-4 mb-4">
            <div class="divisor">
              {{ $t('crear_nuevo_holding') }}
            </div>
          </b-col>
        </b-row>

        <b-form @submit.prevent="submitForm">
          <b-row>
            <b-col md="6">
              <b-form-group label-for="nombre">
                <template v-slot:label>
                  {{ $t('nombre') }} <span class="text-danger">*</span>
                </template>
                <b-form-input id="nombre" v-model="form.nombre" required maxlength="300"
                  :placeholder="$t('nombre')"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group :label="$t('activo')" label-for="activo">
                <b-form-checkbox id="activo" v-model="form.activo" switch class="mt-2">
                  {{ form.activo ? $t('activo') : $t('inactivo') }}
                </b-form-checkbox>
              </b-form-group>
            </b-col>
          </b-row>

          <b-button type="submit" variant="primary">
            {{ $t('guardar') }}
          </b-button>
        </b-form>
      </b-container>
    </base-header>
  </div>
</template>

<script>
import holdingService from '@/api/holdingService';
import Swal from 'sweetalert2';

export default {
  name: 'HoldingCrear',
  data() {
    return {
      form: {
        nombre: '',
        activo: true,
      },
    };
  },
  methods: {
    submitForm() {
      Swal.fire({
        title: this.$t('esta_seguro'),
        text: this.$t('revisa_datos'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t('crear_holding'),
        cancelButtonText: this.$t('cancelar'),
      }).then(async (result) => {
        if (!result.isConfirmed) {
          Swal.close();
          return;
        }

        try {
          Swal.fire({
            html: '<div style="display:flex;align-items:center;justify-content:center;">' +
                  '<img src="/img/others/loading.gif" alt="Loading" style="width:50px;height:50px;margin-right:15px;">' +
                  '<div><h3 style="color:#006393;">' + this.$t('creando') + '</h3></div>' +
                  '</div>',
            showConfirmButton: false,
            allowOutsideClick: false,
          });

          const response = await holdingService.create(this.form);

          if (!response || !response.data) {
            Swal.fire({ icon: 'error', title: 'Oops...', text: 'Ocurrió un error inesperado.' });
            return;
          }

          Swal.fire({
            title: this.$t('creado_correctamente'),
            icon: 'success',
            showConfirmButton: false,
            timer: 2000,
          });

          const data = response.data;
          const newId = (data && data.id) ? data.id : null;

          if (newId) {
            this.$router.push({ name: 'holding-detalle', params: { id: newId } });
          } else {
            this.$router.push({ name: 'holdings' });
          }
        } catch (error) {
          const raw = (error && error.response) ? error.response.data : error;

          let status = 0;
          if (error && error.response && typeof error.response.status !== 'undefined') {
            status = error.response.status;
          }

          let msg = 'Error';
          if (typeof raw === 'string') {
            msg = raw;
          } else if (raw && (raw.message || raw.Message || raw.error || raw.title || raw.detail)) {
            msg = String(raw.message || raw.Message || raw.error || raw.title || raw.detail);
          } else if (error && error.message) {
            msg = error.message;
          } else {
            try { msg = JSON.stringify(raw, null, 2); } catch (e) { msg = 'Error'; }
          }

          const title = (status === 400 || status === 409) ? this.$t('datos_invalidos') : 'Oops...';
          const icon  = (status === 400 || status === 409) ? 'warning' : 'error';

          Swal.fire({
            icon: icon,
            title: title,
            html: '<pre style="font-family: inherit;text-align:center;white-space:pre-wrap;margin:0">' + msg + '</pre>',
          });
        }
      });
    },
  },
};
</script>

<style scoped>
.divisor {
  font-size: 16px;
  font-weight: 400;
  color: #fff;
  padding: 15px;
  background: #6172e9;
  border-radius: 10px;
}
</style>
